import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';
import { NoAuthGuard } from './auth/no-auth.guard';

const authModule = () => import('./auth/auth.module').then(x => x.AuthModule);
const LayoutModule = () => import('./layout/layout.module').then(x => x.LayoutModule);

const routes: Routes = [
  { path: 'er', loadChildren: LayoutModule, canActivate: [authGuard] },
  { path: '', loadChildren: authModule,  canActivate: [NoAuthGuard] },
  { path: '**', redirectTo: '/er' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
